<template>
  <div>
    <div v-if="isMobile === false">
      <div class="MySubscriptions wrapper">
        <keep-alive>
          <Header></Header>
        </keep-alive>

        <div class="top">
          <!--      问答-->
          <div class="flexBox">
            <div class="searchBox">
              <el-dropdown>
                <span class="el-dropdown-link">
                  职位<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              </el-dropdown>
              <span class="spanStyle"> </span>
              <el-input
                v-model="seachInput"
                class="searchContent"
                @keyup.enter.native="Search"
                placeholder="请输入搜索关键词"
              ></el-input>
              <el-button class="searchTo" @click="Search">搜索 </el-button>
            </div>

            <div class="scanEr">
              <Erweima></Erweima>
            </div>
          </div>
          <!--      筛选条件-->
          <div class="filter">
            <!--        城市-->
            <div class="city">
              <div class="main">工作地点：</div>
              <div class="name">
                <li v-for="(citys, index) in cityName" :key="index">
                  <span
                    :class="[citys.selected ? 'active' : '', 'citys']"
                    class="cityName"
                    @click="selectCity(citys)"
                    >{{ citys.content }}</span
                  >
                </li>
                <span
                  class="cityName"
                  style="margin-top: 1px"
                  v-if="other === false"
                  @click="other = true"
                >
                  其他</span
                >
                <span class="cityName" v-else>
                  <input
                    type="text"
                    class="red-border-input"
                    ref="addressInput"
                    v-model="Address"
                    placeholder="其他"
                    @blur="City()"
                /></span>
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--        薪资-->
            <div class="city">
              <div class="main">月薪范围：</div>
              <div class="name">
                <li v-for="(salarys, index) in salaryName" :key="index">
                  <span
                    :class="[salarys.selected ? 'active' : '', 'salarys']"
                    class="cityName"
                    @click="selectSalary(salarys)"
                  >
                    {{ salarys.content }}</span
                  >
                </li>
                <span
                  class="cityName"
                  style="margin-top: 1px"
                  v-if="otherSalary === false"
                  @click="otherSalary = true"
                >
                  其他范围</span
                >
                <span class="cityName" v-else>
                  <input
                    type="text"
                    class="red-border-input"
                    v-model="positionSalary1"
                    placeholder="其他"
                  />
                  -
                  <input
                    type="text"
                    class="red-border-input"
                    v-model="positionSalary2"
                    placeholder="其他"
                    @input="Salary(positionSalary2)"
                  />&nbsp;&nbsp;k</span
                >
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--        学历经验-->
            <div class="city">
              <div class="main">学历要求：</div>
              <div class="name">
                <li v-for="(educations, index) in educationName" :key="index">
                  <span
                    :class="[educations.selected ? 'active' : '', 'educations']"
                    class="cityName"
                    @click="selectEducation(educations)"
                    >{{ educations.content }}</span
                  >
                </li>
              </div>
            </div>

            <div class="spanStyle"></div>
            <!--        工作经验-->
            <div class="city">
              <div class="main2">工作年限：</div>
              <div class="name2">
                <li v-for="(times, index) in timeName" :key="index">
                  <span
                    :class="[times.selected ? 'active' : '', 'times']"
                    class="cityName"
                    @click="selectTime(times)"
                    >{{ times.content }}</span
                  >
                </li>
              </div>
            </div>
            <!--          与选择条件-->
            <div v-if="tags.length > 0" class="select">
              <!--          <div class="select">-->
              <div class="name">已选条件：</div>
              <div style="width: 85%;margin-bottom: 5px">
                <el-tag
                  v-for="tag in tags"
                  :key="tag.name"
                  :disable-transitions="false"
                  :type="tag.type"
                  class="tagStyle"
                  closable
                  @close="handleClose(tag)"
                >
                  {{ tag.name }}
                </el-tag>
              </div>
              <div class="clear" @click="clear()">清除筛选条件</div>
            </div>
          </div>
        </div>

        <div
          style="
            display: flex;
            width: 1280px;
            margin: 0 auto;
            position: relative;
          "
        >
          <div class="middle">
            <li v-for="(lists, index) in list" :key="index">
              <div class="listTotle" @click="personal(lists)">
                <div class="detail">
                  <div>
                    <div>
                      <span class="positionName">
                        {{ lists.positionName }}【{{ lists.positionAddress }}】</span
                      >
                      <span class="salaryName">
                        {{ lists.positionSalary }}</span
                      >
                    </div>
                    <div class="jobStyle">
                      <span class="jobStyle1">{{ lists.positionTime }}</span>
                      <span class="jobStyle2">{{lists.positionEducation }}</span>
                      <span class="jobStyle2">{{lists.positionCategory}}</span>
                    </div>
                  </div>

                  <div class="comButton">
                    <div>
                      <el-avatar :size="45" :src="baseURL +lists.interviewAvatar"></el-avatar>
                    </div>
                    <el-button class="companyBut"
                      >立即沟通</el-button
                    >
                  </div>
                </div>
                <div class="bottom">
                  <div class="comLogo">
                    <img :src="baseURL + lists.companyAvatar" alt="" />
                  </div>
                  <div class="companyName">
                    <div class="name1">{{ lists.companyName }}</div>
                    <div class="spanthis"></div>
                    <div class="name2">{{ lists.companyIndustry }}</div>
                    <div class="name2">{{ lists.companyScale }}</div>
                  </div>
                </div>
              </div>
            </li>
            <!--        分页-->

            <div v-if="list.length === 0" class="pagination-container">
              <div
                style="
                  width: 150px;
                  height: auto;
                  font-size: 16px;
                  margin: 0 auto;
                "
              >
                <img src="../../assets/none.png" alt="" />
              </div>
              <div style="color: black; line-height: 36px; font-size: 18px">
                暂时没有符合该搜索条件的职位
              </div>
              <div style="color: gray; line-height: 36px">
                请重新修改搜索条件后再进行搜索
              </div>
            </div>
            <div v-if="list.length !== 0" class="pagination-container">
              <el-pagination
                v-model="page"
                :current-page="page"
                :page-size="size"
                :page-sizes="[5, 8, 10, 15]"
                :total="total"
                background
                layout=" prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
          <div>
            <div class="jianli" v-if="userId">
              <PersonalLittle></PersonalLittle>
            </div>
            <div class="recommend2" v-else>
              <div @click="showLoginIn1()" class="advertisement">
                <div class="logo"></div>
                <div class="title">
                  <span
                    style="
                      padding: 0 5px;
                      margin: 15px 0 0 auto;
                      width: fit-content;
                      font-size: 16px;
                      font-weight: normal;
                    "
                    ><i class="el-icon-caret-right" style="color: white"></i>
                    去登录</span
                  ><br />
                  <span>找工作</span><br />
                  <span>就来油气人才</span><br />
                  <div
                    style="
                      border-radius: 10px;
                      background-color: rgb(111, 166, 251);
                      padding: 0 5px;
                      margin: 10px 0 0 auto;
                      width: fit-content;
                      font-size: 16px;
                      font-weight: normal;
                    "
                  >
                    油气人才
                  </div>
                </div>
              </div>
              <div @click="showLoginIn()" class="advertisement2">
                <div class="logo"></div>
                <div class="title">
                  <span
                    style="
                      padding: 0 5px;
                      margin: 15px 0 0 auto;
                      width: fit-content;
                      font-size: 16px;
                      font-weight: normal;
                    "
                    ><i class="el-icon-caret-right" style="color: white"></i>
                    去登录</span
                  ><br />
                  <span>海量人才</span><br />
                  <span>在线等你沟通</span><br />
                  <div
                    style="
                      border-radius: 10px;
                      background-color: rgb(111, 166, 251);
                      padding: 0 5px;
                      margin: 10px 0 0 auto;
                      width: fit-content;
                      font-size: 16px;
                      font-weight: normal;
                    "
                  >
                    油气人才
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <LoginTip
          :dialogVisibleLogin="dialogVisible"
          @hideDialog="hideDialog"
        ></LoginTip>
        <InfoTip
          :dialogVisibleInfo="dialogVisibleInfo"
          @hideDialog="hideDialogInfo"
        ></InfoTip>
        <LoginIn
          :dialogVisible="loginIn"
          @hideDialog="hideLoginIn"
          @register="showRegister"
          @forget="forget"
          @logsuccess="logsuccess"
        ></LoginIn>
        <RegisterIn
          :dialogVisible="registerIn"
          @hideDialog="hideregisterIn"
          @login="login"
        ></RegisterIn>
        <forgetIn
          :dialogVisible="forgetIn"
          @hideDialog="hidereforgetIn"
          @login="login"
        ></forgetIn>
      </div>
    </div>
    <div v-if="isMobile === true">
      <div class="MySubscriptions wrapper">
        <keep-alive>
          <Header></Header>
        </keep-alive>

        <div class="top1">
          <!--      问答-->
          <div class="flexBox">
            <div class="searchBox">
              <el-dropdown>
                <span class="el-dropdown-link">
                  职位<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              </el-dropdown>
              <span class="spanStyle"> </span>
              <el-input
                v-model="seachInput"
                class="searchContent"
                @keyup.enter="Search"
                placeholder="请输入搜索关键词"
              ></el-input>
              <el-button class="searchTo" @click="Search">搜索 </el-button>
            </div>
          </div>
          <!--      筛选条件-->
          <div class="filter">
            <!--        城市-->
            <div class="city">
              <div class="main">城市</div>
              <div class="name">
                <li v-for="(citys, index) in cityName" :key="index">
                  <span
                    :class="[citys.selected ? 'active' : '', 'citys']"
                    class="cityName"
                    @click="selectCity(citys)"
                    >{{ citys.content }}</span
                  >
                </li>
                <span
                  class="cityName"
                  style="margin-top: 1px"
                  v-if="other === false"
                  @click="other = true"
                >
                  其他</span
                >
                <span class="cityName" v-else>
                  <input
                    type="text"
                    class="red-border-input"
                    ref="addressInput"
                    v-model="Address"
                    placeholder="其他"
                    @blur="City()"
                /></span>
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--        薪资-->
            <div class="city">
              <div class="main">薪资</div>
              <div class="name">
                <li v-for="(salarys, index) in salaryName" :key="index">
                  <span
                    :class="[salarys.selected ? 'active' : '', 'salarys']"
                    class="cityName"
                    @click="selectSalary(salarys)"
                  >
                    {{ salarys.content }}</span
                  >
                </li>
                <span
                  class="cityName"
                  style="margin-top: 1px"
                  v-if="otherSalary === false"
                  @click="otherSalary = true"
                >
                  其他范围</span
                >
                <span class="cityName" v-else>
                  <input
                    type="text"
                    class="red-border-input"
                    v-model="positionSalary1"
                    placeholder="其他"
                  />
                  -
                  <input
                    type="text"
                    class="red-border-input"
                    v-model="positionSalary2"
                    placeholder="其他"
                    @input="Salary(positionSalary2)"
                  />k</span
                >
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--        学历经验-->
            <div class="city">
              <div class="main">学历</div>
              <div class="name">
                <li v-for="(educations, index) in educationName" :key="index">
                  <span
                    :class="[educations.selected ? 'active' : '', 'educations']"
                    class="cityName"
                    @click="selectEducation(educations)"
                    >{{ educations.content }}</span
                  >
                </li>
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--        职位类别-->
            <div class="city">
              <div class="main2">职位</div>
              <div class="name2">
                <li v-for="(positions, index) in positionName" :key="index">
                  <span
                    :class="[positions.selected ? 'active' : '', 'positions']"
                    class="cityName"
                    @click="selectPosition(positions)"
                    >{{ positions.content }}</span
                  >
                </li>
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--        工作经验-->
            <div class="city">
              <div class="main2">经验</div>
              <div class="name2">
                <li v-for="(times, index) in timeName" :key="index">
                  <span
                    :class="[times.selected ? 'active' : '', 'times']"
                    class="cityName"
                    @click="selectTime(times)"
                    >{{ times.content }}</span
                  >
                </li>
              </div>
            </div>
            <div class="spanStyle"></div>
            <!--          与选择条件-->
            <div v-if="tags.length > 0" class="select">
              <!--          <div class="select">-->
              <div class="name">已选条件：</div>
              <div style="width: 85%;margin-bottom: 5px">
                <el-tag
                  v-for="tag in tags"
                  :key="tag.name"
                  :disable-transitions="false"
                  :type="tag.type"
                  class="tagStyle"
                  closable
                  @close="handleClose(tag)"
                >
                  {{ tag.name }}
                </el-tag>
              </div>
              <div class="clear" @click="clear()">清除筛选条件</div>
            </div>
          </div>
        </div>

        <div style="width: 100%; margin: 0 auto; position: relative">
          <div class="middle1">
            <li v-for="(lists, index) in list" :key="index">
              <div class="listTotle" @click="personal(lists)">
                <div class="detail">
                  <div>
                    <div>
                      <span class="positionName">
                        {{ lists.positionName }}</span
                      >
                      <span class="salaryName">
                        {{ lists.positionSalary }}</span
                      >
                    </div>
                    <div class="jobStyle">
                      <span class="jobStyle1">{{ lists.positionTime }}</span>
                      <span class="jobStyle2">{{lists.positionEducation}}</span>
                      <span class="jobStyle2">{{lists.positionCategory}}</span>
                    </div>
                  </div>
                  <div class="comLogo">
                    <img :src="baseURL + lists.companyAvatar" alt="" />
                  </div>
                  <div class="companyName">
                    <div class="name1">{{ lists.companyName }}</div>
                    <div class="name2">{{ lists.companyScale }}</div>
                  </div>
                  <div class="comButton">
                    <div>
                      <el-avatar :size="45" :src="baseURL +lists.interviewAvatar"></el-avatar>
                    </div>
                    <el-button class="companyBut" >申请职位</el-button>
                  </div>
                </div>
                <div class="bottom">
                  <div class="address"></div>
                  <div class="positionAddress">{{ lists.positionAddress }}</div>
                </div>
              </div>
            </li>
            <!--        分页-->

            <div v-if="list.length === 0" class="pagination-container">
              <div
                style="
                  width: 150px;
                  height: auto;
                  font-size: 16px;
                  margin: 0 auto;
                "
              >
                <img src="../../assets/none.png" alt="" />
              </div>
              <div style="color: black; line-height: 36px; font-size: 18px">
                暂时没有符合该搜索条件的职位
              </div>
              <div style="color: gray; line-height: 36px">
                请重新修改搜索条件后再进行搜索
              </div>
            </div>
            <div v-if="list.length !== 0" class="pagination-container">
              <el-pagination
                v-model="page"
                :current-page="page"
                :total="total"
                background
                layout=" prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>

        <LoginTip
          :dialogVisibleLogin="dialogVisible"
          @hideDialog="hideDialog"
        ></LoginTip>
        <InfoTip
          :dialogVisibleInfo="dialogVisibleInfo"
          @hideDialog="hideDialogInfo"
        ></InfoTip>
        <LoginIn
          :dialogVisible="loginIn"
          @hideDialog="hideLoginIn"
          @register="showRegister"
          @forget="forget"
          @logsuccess="logsuccess"
        ></LoginIn>
        <RegisterIn
          :dialogVisible="registerIn"
          @hideDialog="hideregisterIn"
          @login="login"
        ></RegisterIn>
        <forgetIn
          :dialogVisible="forgetIn"
          @hideDialog="hidereforgetIn"
          @login="login"
        ></forgetIn>
      </div>
    </div>

    <Footer v-if="isMobile === false"></Footer>
    <BottomBanner v-if="isMobile === true"></BottomBanner>
  </div>
</template>


<script>
import { getAuthorize } from "@/api/user";

import Header from "@/components/Header.vue";
import BottomBanner from "@/components/BottomBanner.vue";
import Footer from "@/components/Footer.vue";
import Erweima from "@/views/candidate/Erweima.vue";
import PersonalLittle from "@/components/PersonalLittle.vue";
import RegisterIn from "@/views/userlog/RegisterIn.vue";
import LoginTip from "@/components/LoginTip.vue";
import LoginIn from "@/views/userlog/LoginIn.vue";
import forgetIn from "@/views/userlog/forgetIn.vue";
import InfoTip from "@/components/InfoTip.vue";

export default {
  name: "",

  props: [],

  components: {
    InfoTip,
    forgetIn,
    LoginIn,
    LoginTip,
    RegisterIn,
    Erweima,
    PersonalLittle,
    Footer,
    BottomBanner,
    Header,
  },

  data() {
    return {
      other: false,
      otherSalary: false,
      Address: "",
      positionSalary1: "",
      positionSalary2: "",
      dialogVisible: false,
      dialogVisibleInfo: false,
      registerIn: false,
      forgetIn: false,
      userId: localStorage.getItem("userId"),
      seachInput: "",
      isactive: 0,
      isMobile: false,
      token: localStorage.getItem("access_token"),
      cityName: [],
      salaryName: [],
      positionName: [],
      timeName: [],
      educationName: [],
      tags: [],
      page: 1,
      size: 8,
      total: "",
      list: [],
      baseURL: this.$utils.baseURL,
      keysWords: "",
      positionAddress: [],
      positionSalary: "",
      positionEducation: [],
      positionCategory: [],
      positionTime: "",
      loginIn: false,
    };
  },
  beforeRouteUpdate(to, from, next) {
    window.scrollTo(0, 0); // 每次路由变化时滚动到页面顶部
    next();
  },
  created() {
    this.city();
    this.salary();
    this.position();
    this.time();
    this.education();
    this.positionlist();
  },
  methods: {
    hideDialog() {
      this.dialogVisible = false;
    },
    hideDialogInfo() {
      this.dialogVisibleInfo = false;
    },
    hideLoginIn() {
      this.loginIn = false;
    },
    logsuccess() {
      this.loginIn = false;
      this.userId = this.$store.state.userId;
      window.location.reload();
    },
    showRegister() {
      this.loginIn = false;
      this.registerIn = true;
    },
    forget() {
      this.loginIn = false;
      this.forgetIn = true;
    },
    hideregisterIn() {
      this.registerIn = false;
    },
    hidereforgetIn() {
      this.forgetIn = false;
    },
    login() {
      this.loginIn = true;
      this.registerIn = false;
    },

    showLoginIn() {
      this.loginIn = true;
    },
    showLoginIn1() {
      // this.$router.push("/login")
      let href = window.location.href.split("&code")[0];
      getAuthorize(href).then((res) => {
        console.log(res, "ress");
        window.location.replace(res.data.url);
      });
    },
    onKeyDown(event) {
      if (event.keyCode === 13) {
        // 如果按下的是回车键，执行搜索功能
        this.$refs.addressInput.blur();
        this.Search();
      }
    },
    // 多选
    selectCity(items) {
      if (items.selected === false) {
        items.selected = true;
        this.positionAddress += items.content + ",";
        console.log(this.positionAddress);
        this.tags.push({ name: items.content, id: "city", type: "danger" });
        this.positionlist();
      }
    },
    City() {
      this.positionAddress += this.Address + ",";
      console.log(this.positionAddress);
      this.tags.push({ name: this.Address, id: "city", type: "danger" });
      this.positionlist();
    },
    Salary() {
      this.salaryName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      this.positionSalary = "";
      this.tags = this.tags.filter((tag) => tag.id !== "salary");

      this.positionSalary =
        this.positionSalary1 + "-" + this.positionSalary2 + "k";
      this.tags.push({
        name: this.positionSalary,
        id: "salary",
        type: "danger",
      });
      this.positionlist();
    },
    // 单选
    selectSalary(items) {
      this.salaryName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      items.selected = true;
      this.positionSalary = items.content;
      // 监察名为'salary'的标签并将其删除
      this.tags = this.tags.filter((tag) => tag.id !== "salary");
      this.tags.push({ name: items.content, id: "salary", type: "danger" });
      this.positionlist();
    },
    // 多选
    selectEducation(items) {
      if (items.selected === false) {
        items.selected = true;
        this.positionEducation += items.content + ",";
        this.tags.push({
          name: items.content,
          id: "education",
          type: "danger",
        });
        this.positionlist();
      }
    },
    // 多选
    selectPosition(items) {
      if (items.selected === false) {
        items.selected = true;
        this.positionCategory += items.content + ",";
        this.tags.push({ name: items.content, id: "position", type: "danger" });
        this.positionlist();
      }
    },
    // 单
    selectTime(items) {
      this.timeName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      items.selected = true;
      this.positionTime = items.content;
      this.tags = this.tags.filter((tag) => tag.id !== "time");
      this.tags.push({ name: items.content, id: "time", type: "danger" });
      this.positionlist();
    },
    Search() {
      this.keysWords = this.seachInput;
      this.positionlist();
    },
    // 详情
    personal(list) {
      console.log(list);
      this.$router.push({
        path: "/positionDetail",
        query: {
          positionId: list.positionId,
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.size = val;
      this.positionlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      // this.handleScroll();
      // console.log(`当前页: ${val}`+this.page)
      this.$forceUpdate(); //强制重新渲染分页器组件
      this.positionlist();
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      // 当需要删除特定标签时

      if (tag.id === "city") {
        this.positionAddress = this.positionAddress.split(",");
        const index1 = this.cityName.findIndex(
          (item) => item.content === tag.name
        );
        if (index1 !== -1) {
          this.cityName[index1].selected = false;
        }
        const index = this.positionAddress.findIndex(
          (item) => item === tag.name
        );
        if (index !== -1) {
          this.positionAddress.splice(index, 1); // 从 positionCategory 数组中删除特定项目
          this.positionAddress = this.positionAddress.join(","); // 将数组转换回以逗号分隔的字符串
          if (this.positionAddress.length === 0) {
            this.positionAddress = [];
          }
          this.positionlist();
        }
      }
      // 将字符串转换为数组（假设 this.positionCategory 是以逗号分隔的字符串）

      if (tag.id === "position") {
        this.positionCategory = this.positionCategory.split(",");
        const index1 = this.positionName.findIndex(
          (item) => item.content === tag.name
        );
        if (index1 !== -1) {
          this.positionName[index1].selected = false;
        }
        const index = this.positionCategory.findIndex(
          (item) => item === tag.name
        );
        if (index !== -1) {
          this.positionCategory.splice(index, 1); // 从 positionCategory 数组中删除特定项目
          this.positionCategory = this.positionCategory.join(","); // 将数组转换回以逗号分隔的字符串
          if (this.positionCategory.length === 0) {
            this.positionCategory = [];
          }
          this.positionlist(); // 执行其他相关操作
        }
      }

      if (tag.id === "education") {
        this.positionEducation = this.positionEducation.split(",");
        const index1 = this.educationName.findIndex(
          (item) => item.content === tag.name
        );
        if (index1 !== -1) {
          this.educationName[index1].selected = false;
        }
        const index = this.positionEducation.findIndex(
          (item) => item === tag.name
        );
        if (index !== -1) {
          this.positionEducation.splice(index, 1); // 从 positionCategory 数组中删除特定项目
          this.positionEducation = this.positionEducation.join(","); // 将数组转换回以逗号分隔的字符串
          if (this.positionEducation.length === 0) {
            this.positionEducation = [];
          }

          this.positionlist();
        }
      }
      if (tag.id === "time") {
        this.timeName.forEach((item) => {
          item.selected = false; // 将所有项目的 selected 设置为 false
        });
        this.positionTime = "";
        this.positionlist();
      }
      if (tag.id === "salary") {
        this.salaryName.forEach((item) => {
          item.selected = false; // 将所有项目的 selected 设置为 false
        });
        this.positionSalary = "";
        this.positionlist();
      }
    },
    clear() {
      this.tags = [];
      this.cityName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      this.salaryName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      this.positionName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      this.timeName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      this.educationName.forEach((item) => {
        item.selected = false; // 将所有项目的 selected 设置为 false
      });
      this.keysWords = "";
      this.positionAddress = [];
      this.positionSalary = "";
      this.positionEducation = [];
      this.positionCategory = [];
      this.positionTime = "";
      this.seachInput = "";
      this.positionlist();
    },
    city() {
      this.$axios
        .get("/system/city/list", {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then((res) => {
          this.cityName = res.data.rows;
          this.cityName.forEach((item) => {
            item.selected = false; // 将所有项目的 selected 设置为 false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    salary() {
      this.$axios
        .get("/system/salary/list", {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then((res) => {
          this.salaryName = res.data.rows;
          this.salaryName.forEach((item) => {
            item.selected = false; // 将所有项目的 selected 设置为 false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    position() {
      this.$axios
        .get("/system/position_category/list", {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then((res) => {
          this.positionName = res.data.rows;
          this.positionName.forEach((item) => {
            item.selected = false; // 将所有项目的 selected 设置为 false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    time() {
      this.$axios
        .get("/system/time/list", {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then((res) => {
          this.timeName = res.data.rows;
          this.timeName.forEach((item) => {
            item.selected = false; // 将所有项目的 selected 设置为 false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    education() {
      this.$axios
        .get("/system/education/list", {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then((res) => {
          this.educationName = res.data.rows;
          this.educationName.forEach((item) => {
            item.selected = false; // 将所有项目的 selected 设置为 false
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    positionlist() {
      this.$axios
        .get("/system/position/screen_list", {
          params: {
            pageNum: this.page,
            pageSize: this.size,
            positionName: this.keysWords,
            positionAddress: this.positionAddress,
            positionSalary: this.positionSalary,
            positionEducation: this.positionEducation,
            positionCategory: this.positionCategory,
            positionTime: this.positionTime,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then((res) => {
          console.log();
          console.log("------------=====================");
          console.log(res.data);
          this.total = res.data.total;
          this.list = res.data.rows;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    document.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
    window.scrollTo(0, 0); // 在页面加载时滚动到页面顶部
    // Check if the device width is less than 768px (example for mobile)
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
  },
};
</script>


<style lang="scss" scoped type="text/scss">
.red-border-input {
  text-align: center;
  margin-top: -5px;
  width: 30px;
  border: 1px solid var(--main-color); /* 设置边框为红色 */
  border-radius: 4px; /* 设置边框圆角 */
  padding: 8px; /* 设置内边距 */
  outline: none; /* 去除默认的轮廓样式 */
}

/* 鼠标悬浮时，增加一些样式 */
.red-border-input:hover {
  border: 2px solid var(--main-color); /* 悬浮时增加边框宽度 */
}
.recommend2 {
  right: 0;
  position: absolute;
  width: 280px;
  height: 340px;
  top: 20px;
  //box-shadow: 0px 0px 1.4vh 0px rgba(0,0,0,0.05);
  border-radius: 4px 4px 4px 4px;
  .item {
    width: 100%;
    cursor: pointer;
    padding: 2.3vh 1vw;
    font-size: 18px;
    color: #333333;
  }
  .item:hover {
    background: var(--main-color);
    color: #fff;
  }
  .item:not(:last-child) {
    border-bottom: 1px dotted #cecece;
  }
}
.top {
  overflow-x: hidden;
  margin: 30px auto;
  width: 1280px;
  height: fit-content;
  background: #ffffff;
  border-radius: 5px;
  opacity: 1;
  position: relative;

  .flexBox {
    display: flex;
    border-radius: 4px;
    width: 1250px;
    margin: 2.9vh auto 0 auto;
    font-size: 14px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
    height: 7.2vh;

    .spanStyle {
      width: 1px;
      font-size: 16px;
      height: 1.48vh;
      background: #d9d9d9;
    }

    .el-dropdown {
      width: 5.63vw;
      margin-left: 15px;
    }

    .el-dropdown-link {
      margin-left: 0.7vw;
      cursor: pointer;
      color: #333333;
    }

    .el-icon-arrow-down {
      font-size: 16px;
    }

    .searchBox {
      border: 1px solid #bf0022;
      border-radius: 105px;
      width: 80%;
      height: 56px;
      margin: -2px 0;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      //border: 1px solid var(--main-color);
      ::v-deep .el-button {
        padding: 0.8vh 0.7vw !important;
      }

      .searchContent {
        border-radius: 0;
        height: 4.5vh;

        ::v-deep .el-input__inner {
          height: 100%;
        }

        ::v-deep .el-input__inner::placeholder {
          color: #999;
        }
      }

      .searchTo {
        width: 6.7vw;
        height: 5.2vh;
        color: white;
        font-size: 14px;
        border: none;
        margin-right: 8px;
        background: #bf0022;
        border-radius:  105px;

        img {
          width: 1.1vw;
          height: 1.9vh;
        }
      }
    }

    .searchBox:hover {
      border: 1px solid #bf0022;}

    .scanEr {
      top:15px;
      position: absolute;
      right: 25px;
      display: flex;
      background: #feffff;
    }
  }

  .filter {
    width: 1230px;
    margin: 30px auto 30px auto;

    .city {
      margin-top: 14px;
      display: flex;

      .main {
        width:fit-content;
        height: 22px;
        font-size: 14px;
        //font-weight: bold;
        color: #333333;
        line-height: 19px;
      }

      .main2 {
        width:fit-content;
        height: 22px;
        font-size: 14px;
        //font-weight: bold;
        color: #333333;
        line-height: 19px;
      }

      .name {
        list-style: none;
        margin-left: 1.5vw;
        display: flex;
        cursor: pointer;

        .cityName {
          font-size: 14px;
          font-weight: 400;
          margin-right: 1.14vw;
          color: #333333;
          line-height: 16px;
        }

        .cityName.active {
          color: #fd6300;;
        }

        .cityName:hover {
          color:#fd6300;
          font-weight: 500;
        }
      }

      .name2 {
        list-style: none;
        margin-left: 1.5vw;
        display: flex;
        cursor: pointer;

        .cityName {
          font-size: 14px;
          font-weight: 400;
          margin-right: 1.14vw;
          color: #333333;
          line-height: 16px;
        }

        .cityName.active {
          color: #fd6300;;
        }

        .cityName:hover {
          color: #fd6300;;
          font-weight: 700;
        }
      }
    }

    .select {
      width: 100%;
      margin: 29px 0;
      position: relative;
      justify-content: flex-start; /* 将内部元素均匀分布 */
      display: flex;

      .name {
        width:fit-content;
        height: 16px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }

      .tagStyle {
        width: auto;
        padding: 2px 12px;
        background:  #fd6300;
        margin-left: 16px;
        margin-top: -5px ;
        margin-bottom: 15px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
      }
      .el-tag.el-tag--danger {
        background-color: #fd6300;
        border-color: #fd6300;
        color: white;
      }
      ::v-deep .el-tag.el-tag--danger .el-tag__close {
        color: white !important;
      }
      .clear {
        width: 84px;
        height: 14px;
        right: 0;
        position: absolute;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        float: right;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
      }

      .clear:hover {
        color: #bf0022;
      }
    }

    .spanStyle {
      margin-top: 12px;
      width: 100%;
      height: 1px;
      background: #f5f5f5;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
  }
}
.top1 {
  overflow-x: hidden;
  margin: 10px auto;
  width: 100%;
  min-height: 350px;
  background: #ffffff;
  border-radius: 5px;
  opacity: 1;
  position: relative;

  .flexBox {
    border-radius: 4px;
    width: 100%;
    margin: 2.9vh auto 0 auto;
    font-size: 14px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
    height: 7.2vh;

    .spanStyle {
      width: 1px;
      font-size: 16px;
      height: 1.48vh;
      background: #d9d9d9;
    }

    .el-dropdown {
      width: 20.63vw;
    }

    .el-dropdown-link {
      margin-left: 0.7vw;
      cursor: pointer;
      color: #333333;
    }

    .el-icon-arrow-down {
      font-size: 16px;
    }

    .searchBox {
      border: 1px solid #bf0022;
      border-radius: 4px 4px 4px 4px;
      width: 80%;
      margin-left: 10%;
      height: 5.2vh;
      margin: auto 10%;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      //border: 1px solid var(--main-color);
      ::v-deep .el-button {
        padding: 0.8vh 0.7vw !important;
      }

      .searchContent {
        border-radius: 0;
        height: 4.5vh;

        ::v-deep .el-input__inner {
          height: 100%;
        }

        ::v-deep .el-input__inner::placeholder {
          color: #999;
        }
      }

      .searchTo {
        width: 16vw;
        height: 5.2vh;
        color: white;
        font-size: 14px;
        border: none;
        background: #bf0022;
        border-radius: 4px 4px 4px 4px;

        img {
          width: 1.1vw;
          height: 1.9vh;
        }
      }
    }

    .scanEr {
      position: absolute;
      right: 25px;
      display: flex;
      background: #feffff;
    }
  }

  .filter {
    width: 90%;
    margin: 0.17vh auto 0 auto;

    .city {
      margin-top: 14px;
      display: flex;

      .main {
        width:fit-content;
        height: 22px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 19px;
      }

      .main2 {
        width:fit-content;
        height: 22px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 19px;
      }

      .name {
        list-style: none;
        margin-left: 3.23vw;
        display: flex;
        cursor: pointer;

        .cityName {
          font-size: 12px;
          font-weight: 400;
          margin-right: 1.14vw;
          color: #333333;
          line-height: 16px;
        }

        .cityName.active {
          color: #bf0022;
        }

        .cityName:hover {
          color: #bf0022;
          font-weight: 500;
        }
      }

      .name2 {
        list-style: none;
        margin-left: 1.5vw;
        display: flex;
        cursor: pointer;

        .cityName {
          font-size: 12px;
          font-weight: 400;
          margin-right: 1.14vw;
          color: #333333;
          line-height: 16px;
        }

        .cityName.active {
          color: #bf0022;
        }

        .cityName:hover {
          color: #bf0022;
          font-weight: 500;
        }
      }
    }

    .select {
      width: 66vw;
      margin: 29px 0;
      position: relative;
      justify-content: flex-start; /* 将内部元素均匀分布 */
      display: flex;

      .name {
        width: 70px;
        height: 16px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }

      .tagStyle {
        width: auto;
        padding: 2px 12px;
        background: #faebee;
        margin-left: 16px;
        margin-top: -5px;
        margin-bottom: 15px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
      }

      .clear {
        width: 84px;
        height: 14px;
        right: -25vw;
        position: absolute;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        float: right;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
      }

      .clear:hover {
        color: #bf0022;
      }
    }

    .spanStyle {
      margin-top: 12px;
      width: 100%;
      height: 1px;
      background: #f5f5f5;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
  }
}
.middle {
  overflow: hidden;
  width: 78%;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  list-style: none;
  min-height: 50vh;

  .pagination-container {
    position: sticky;
    margin-top: 20px;
    padding: 25px;
    bottom: 15px;
    width: 99%;
    text-align: center;
    ::v-deep .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #fd6300 !important;
    }
  }

  .listTotle {
    margin-top: 20px;
    width: 100%;
    height: fit-content;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;

    .detail {
      padding: 20px 20px 5px 20px;
      display: flex;
      cursor: pointer;
      position: relative;

      .positionName {
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
      }

      .positionName:hover {
        color: #bf0022;
        transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
      }
      .salaryName {
        margin-left: 12px;
        width: 41px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 700;
        color: #fd6300;
        line-height: 16px;
      }

      .jobStyle {
        display: flex;
        margin-top: 16px;
        width: 18vw;

        .jobStyle1 {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          border-radius: 6px;
          background-color: #d5d5d5;
          padding: 3px 10px;
        }

        .jobStyle1:hover {
          color: #bf0022;
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }

        .jobStyle2 {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          background-color: #d5d5d5;
          border-radius: 6px;
          padding: 3px 10px;
          margin-left: 12px;
        }

        .jobStyle2:hover {
          color: #bf0022;
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }
      }



      .comButton {
        position: absolute;
        right: 45px;
        top: 25px;
        text-align: center;

        .companyBut {
          margin-top: 10px;
          width: 92px;
          height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: white;
          background: #416dfd;
          border-radius: 23px;
          opacity: 1;
          border: 1px solid #fdfdfd;
        }

        .companyBut:hover {
          /* 此处是鼠标悬浮时的样式 */
          color: rgba(100, 98, 98);
          background: #fdfdfd;
          border:  #416dfd  1px solid;
          /* 你可以添加其他的样式以突出悬浮状态 */
        }

        ::v-deep .el-button {
          padding: 5px 10px;
        }
      }
    }

    .bottom {
      padding: 18px 20px;
      width: 100%;
      height: fit-content;
      opacity: 1;
      display: flex;
      cursor: pointer;
      .comLogo {
        width: 22px;
        height: 22px;
        border: rgba(100, 98, 98, 0.1) 1px solid;
        border-radius: 4px;
        opacity: 1;
      }

      .comLogo:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
      }
      .companyName {
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
        margin-left: 8px;
        display: flex;

        .spanthis{
          width: 1px;
          margin: 3px 0 auto 16px;
          height: 16px;
          background-color: #e0dddd;
        }
        .name1 {
          width: fit-content;
          height: 22px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #050505;
          line-height: 22px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .name1:hover {
          color: #bf0022;
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }

        .name2 {
          height: 22px;
          margin-left: 12px;
          font-size: 13px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
        }
        .name2:hover {
          color: #bf0022;
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }
      }

    }
  }
  .listTotle:hover {
    box-shadow: 2px 2px 16px 0px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
  }
}

.middle1 {
  overflow: hidden;
  width: 95%;
  margin: 0 auto;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  list-style: none;

  .pagination-container {
    position: sticky;
    margin-top: 20px;
    padding: 25px;
    bottom: 15px;
    width: 99%;
    text-align: center;
    ::v-deep .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #fd6300 !important;
    }
  }

  .listTotle {
    margin-top: 20px;
    width: 100%;
    height: 142px;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;

    .detail {
      padding: 20px;
      display: flex;
      cursor: pointer;
      position: relative;

      .positionName {
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
      }

      .positionName:hover {
        color: #bf0022;
        transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
      }
      .salaryName {
        margin-left: 12px;
        width: 41px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #bf0022;
        line-height: 16px;
      }

      .jobStyle {
        display: flex;
        margin-top: 16px;
        width: 18vw;

        .jobStyle1 {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          background-color: #f5f5f5;
          padding: 3px 10px;
        }

        .jobStyle1:hover {
          color: #bf0022;
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }

        .jobStyle2 {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          background-color: #f5f5f5;
          padding: 3px 10px;
          margin-left: 0.42vw;
        }

        .jobStyle2:hover {
          color: #bf0022;
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }
      }

      .comLogo {
        position: absolute;
        width: 65px;
        height: 65px;
        top: 15px;
        border: rgba(100, 98, 98, 0.1) 1px solid;
        border-radius: 4px;
        opacity: 1;
        margin-left: 24vw;
      }

      .comLogo:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
      }
      .companyName {
        position: absolute;
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
        margin-left: 29.2vw;

        .spanthis{
          width: 1px;
          height: 16px;
          color: #666666;
        }
        .name1 {
          width: 140px;
          margin-top: 6px;
          height: 16px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #050505;
          line-height: 16px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .name1:hover {
          color: #bf0022;
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }

        .name2 {
          height: 16px;
          margin-top: 10px;
          font-size: 13px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 16px;
        }
        .name2:hover {
          color: #bf0022;
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }
      }

      .comButton {
        position: absolute;
        right: 20px;
        top: 31px;

        .companyBut {
          width: 92px;
          height: 32px;
          border: none;
          font-size: 14px;
          font-weight: 400;
          color: #bf0022;
          background: #faebee;
          border-radius: 15px 15px 15px 15px;
          opacity: 1;
        }

        .companyBut:hover {
          /* 此处是鼠标悬浮时的样式 */
          color: #ffffff;
          background: #bf0022;
          /* 你可以添加其他的样式以突出悬浮状态 */
        }

        ::v-deep .el-button {
          padding: 5px 10px;
        }
      }
    }

    .bottom {
      padding: 18px 20px;
      width: 100%;
      height: 48px;
      background: linear-gradient(99deg, #faebee 0%, #fcfbfa 62%);
      opacity: 1;
      display: flex;
      cursor: pointer;

      .address {
        width: 10px;
        height: 12px;
        background-image: url("../../assets/addressbg.png");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }

      .positionAddress {
        height: 16px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 16px;
        margin-left: 5px;
        margin-top: -2px;
      }
      .positionAddress:hover {
        color: #bf0022;
        transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
      }
    }
  }
  .listTotle:hover {
    box-shadow: 2px 2px 16px 0px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
  }
}
.advertisement {
  position: absolute;
  right: 0;
  width: 260px;
  height: 170px;
  border-radius: 10px;
  cursor: pointer;

  background: rgb(163, 212, 237);
  //border: black 10px solid;
  .logo {
    opacity: 12;
    width: 50%;
    height: 100%;
    background-image: url("../../assets/login.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent; /* 这里设置背景颜色为透明 */
  }
  .title {
    line-height: 30px;
    color: white;
    text-align: right;

    top: 15px;
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 22px;
  }
}
.advertisement2 {
  top: 180px;
  margin-top: 15px;
  position: absolute;
  right: 0;
  width: 260px;
  height: 170px;
  border-radius: 10px;
  background-color: #30539d;
  cursor: pointer;
  //border: black 10px solid;
  .logo {
    opacity: 12;
    width: 50%;
    height: 100%;
    background-image: url("../../assets/login.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent; /* 这里设置背景颜色为透明 */
  }
  .title {
    line-height: 30px;
    color: white;
    text-align: right;

    top: 15px;
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 22px;
  }
}
.jianli {
  margin: 20px 0 0 20px;
  width: 260px;
  height: 267px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}
</style>
